<div
  v-if="isMobile && isMobileSidebarOpen"
  class="mobile-sidebar-overlay"
  @click="closeMobileSidebar"
></div>

<aside
  class="is-expanded"
  :class="{ 'mobile-open': isMobile && isMobileSidebarOpen }"
>
  <div class="menu-toggle-wrap">
    <img
      src="@/assets/images/sideBar/new-logo.svg"
      alt="AprenderCreando"
      @click="goHome"
    />
    <!-- Mobile Close Button -->
    <button
      v-if="isMobile"
      class="mobile-close-btn"
      @click="closeMobileSidebar"
    >
      <i class="fas fa-times"></i>
    </button>
    <!-- <button class="menu-toggle" @click="$emit('toggleExpanded')">
      <img class="logo-menu" src="@/assets/images/DoubleArrow.png" />
    </button> -->
  </div>

  <div class="logo-container">
    <img
      class="logo"
      src="@/assets/images/sideBar/user-profile.svg"
      alt="AprenderCreando"
    />
  </div>

  <div class="user-data">
    <span class="name">{{ nombreCompleto }}</span>
    <span>{{ rol }}</span>
  </div>

  <!--
        <div class="menu-icon">
            <button v-if="isExpanded" class="menu-icon" @click="goAnuncios">MIS ANUNCIOS</button>
            <button v-if="!isExpanded" class="menu-icon" @click="goAnuncios">
                <img src="@/assets/images/sideBar/anuncios-logo.png">
            </button>
        </div>
        -->

  <!--
        <div class="menu-icon">
            <button v-if="isExpanded" class="menu-icon" @click="goMensajes">MIS MENSAJES</button>
            <button v-if="!isExpanded" class="menu-icon" @click="goMensajes">
                <img src="@/assets/images/sideBar/mensajes-logo.png">
            </button>
        </div>
    -->

  <div class="menu-column" v-if="rol">
    <button
      class="menu-icon"
      :class="{ 'is-active': isActive('home') }"
      @click="goHome"
    >
      <img
        :src="require(`@/assets/images/sideBar/home-icon-${isActive('home') ? 'dark' : 'light'}.svg`)"
        class="mr-3"
      />
      Inicio
      <span class="inner" v-if="isActive('home')"></span>
    </button>

    <button
      v-if="rol === 'admin' || rol === 'superadmin'"
      class="menu-icon"
      @click="goUsuarios"
    >
      Usuarios
    </button>

    <button v-if="rol === 'teacher'" class="menu-icon" @click="goMyProfile">
      Mi Perfil
    </button>

    <button
      v-if="rol === 'teacher' || rol === 'student'"
      class="menu-icon"
      :class="{ 'is-active': isActive('cursos') || isActive('quiz') }"
      @click="goCursos"
    >
      <img
        :src="require(`@/assets/images/sideBar/courses-icon-${isActive('cursos') || isActive('quiz') ? 'dark' : 'light'}.svg`)"
        class="mr-3"
      />
      Cursos
      <span class="inner" v-if="isActive('cursos') || isActive('quiz')"></span>
    </button>

    <button v-if="rol != 'student'" class="menu-icon" @click="goMatricula">
      Matrícula
    </button>
  </div>

  <!-- Logout Button - Mobile Only -->
  <div class="logout-section" v-if="isMobile">
    <button class="menu-icon logout-button" @click="handleSignOut">
      <img src="@/assets/icons/logout.svg" alt="Logout" />
      Cerrar Sesión
    </button>
  </div>
</aside>
